import { render, staticRenderFns } from "./GiftsHeader.vue?vue&type=template&id=16a2ed11&"
import script from "./GiftsHeader.vue?vue&type=script&lang=ts&"
export * from "./GiftsHeader.vue?vue&type=script&lang=ts&"
import style0 from "./GiftsHeader.vue?vue&type=style&index=0&id=16a2ed11&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports